import React, { useState } from "react";
import Button from "@fv-components/button";
import { logoutMSALPopup } from "../util-helpers/msal";
import SignoutAction from "../fvid-auth/signoutAction";
import ErrorMsg from "../ErrorMsg";
import { version } from "../version.json";
import { useAuth } from "../fvid-auth/authContext";

const css = require("./SignoutMenu.module.scss");

const SignoutMenu = () => {
  const [errorMsg, setErrorMsg] = useState("");
  const { resetMSAL } = useAuth();

  const handleSignOutMSAL = () => {
    setErrorMsg("");
    try {
      logoutMSALPopup(
        () => {
          resetMSAL();
        },
        (error: string) => {
          // Reset MSAL even on error
          resetMSAL();
          setErrorMsg(error);
        }
      );
    } catch (error) {
      setErrorMsg(`${error}`);
    }
  };
  return (
    <div className={css.signoutMenuFooter}>
      <div className={css.signOutMenuContainer}>
        <SignoutAction />
        <Button className={css.signOutBtn} onClick={handleSignOutMSAL}>
          Sign out of
          <br />
          Microsoft
        </Button>

        {errorMsg && <ErrorMsg errorText={errorMsg} />}
      </div>
      <div className={css.versionContainer}>
        Version:
        {version}
      </div>
    </div>
  );
};

export default SignoutMenu;
